import React from "react";
import assetimages from "./common/assetimages";
import { Link } from "react-router-dom";
import { errorToast } from "./common/showtoast";
import DatePicker from "react-datepicker";
import ApiRequest from "./common/restservice";
import moment from "moment";

import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
export default class Register extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      steps: 1,
      email: "",
      password: "",
      confirmpassword: "",
      mobile: "",
      name: "",
      sponsorid: "",
      city: "",
      country: "",
      tpassword: "",
      confirmtpassword: "",
      aadhar: "",
      pan: "",
      ifsc: "",
      branch_name: "",
      bank_name: "",
      account_number: "",
      checkname: "",
      nmrelation: "",
      nmname: "",
      zipcode: "",
      pos: "",
      state: "",
      district: "",
      address3: "",
      address2: "",
      address1: "",
      dob: "",
      sex: "",
      termsandconditions: false,
      pickrStyle: {},
      backText1: "Already have an account? ",
      backText2: "Login here"
    }
  }
  componentDidMount() {
    this.setState({
      pickrStyle: window.innerWidth < 720 ? {
        border: "1px solid #d5dae2", padding: "15px 25px",
        marginBottom: "20px",
        minHeight: "45px",
        fontSize: "13px",
        lineHeight: "15",
        fontWeight: "normal",
        borderRadius: "5px",
        background: "transparent"
      } : {}
    })
    if (this.props.match.params) {
      this.setState({
        sponsorid: this.props.match.params.ref ? this.props.match.params.ref : ""
      });
      if (Object.keys(this.props.match.params).length !== 0) {
        this.setState({
          backText1: "Go to ",
          backText2: "Epin"
        });
      }
    }
  }

  async RegStep1() {
    this.setState({
      steps: 2
    })
  }
  async actReg() {
    if (!this.state.sponsorid) {
      errorToast("Enter valid sponsorid");
      return;
    } else if (!this.state.mobile) {
      errorToast("Enter valid mobile");
      return;
    }
    else if (!this.state.email) {
      errorToast("Enter valid email");
      return;
    }
    else if (!this.state.name) {
      errorToast("Enter valid fullname");
      return;
    }
    else if (!this.state.sex) {
      errorToast("Select valid gender");
      return;
    } else if (!this.state.dob) {
      errorToast("Enter valid date of birth");
      return;
    } else if (!this.state.password) {
      errorToast("Enter valid password");
      return;
    } else if (!this.state.confirmpassword) {
      errorToast("Enter valid confirmpassword");
      return;
    } else if (this.state.password !== this.state.confirmpassword) {
      errorToast("Password Mismatched");
      return;
    } 
    // else if (!this.state.address1) {
    //     errorToast("Enter valid address line 1");
    //     return;
    // } else if (!this.state.address2) {
    //     errorToast("Enter valid address line 2");
    //     return;
    // } else if (!this.state.address3) {
    //     errorToast("Enter valid address line 3");
    //     return;
    // } else if (!this.state.city) {
    //     errorToast("Enter valid city");
    //     return;
    // } else if (!this.state.state) {
    //     errorToast("Enter valid state");
    //     return;
    // } else if (!this.state.country) {
    //     errorToast("Enter valid country");
    //     return;
    // } else if (!this.state.zipcode) {
    //     errorToast("Enter valid zipcode");
    //     return;
    // }
    else if (!this.state.checkname) {
      errorToast("Enter valid account name");
      return;
    } else if (!this.state.aadhar || this.state.aadhar.length !== 12) {
      errorToast("Enter valid aadhar number");
      return;
    } else if (!this.state.pan || !this.checkValidPan(this.state.pan)) {
      errorToast("Enter valid pan number");
      return;
    } else if (!this.state.account_number) {
      errorToast("Enter valid account number");
      return;
    } else if (!this.state.ifsc) {
      errorToast("Enter valid ifsc");
      return;
    } else if (!this.state.bank_name) {
      errorToast("Enter valid bank name");
      return;
    } else if (!this.state.branch_name) {
      errorToast("Enter valid branch name");
      return;
    } else if (!this.state.nmname) {
      errorToast("Enter valid nominee name");
      return;
    } else if (!this.state.nmrelation) {
      errorToast("Select valid nominee relationship");
      return;
    } else if (!this.state.termsandconditions) {
      errorToast("Please read terms & conditions carefully then accept to continue");
      return;
    }
    let jsoninput = {
      aadhar: this.state.aadhar,
      pan: this.state.pan,
      ifsc: this.state.ifsc,
      branch_name: this.state.branch_name,
      bank_name: this.state.bank_name,
      account_number: this.state.account_number,
      checkname: this.state.checkname,
      nmrelation: this.state.nmrelation,
      nmname: this.state.nmname,
      email: this.state.email,
      mobile: this.state.mobile,
      zipcode: this.state.zipcode,
      country: this.state.country,
      state: this.state.state,
      district: this.state.city,
      city: this.state.city,
      address3: this.state.address3,
      address2: this.state.address2,
      address1: this.state.address1,
      dob: moment(this.state.dob).format("MM/DD/yyyy"),
      sex: this.state.sex,
      sponsorid: this.state.sponsorid,
      login_password: this.state.password,
      fullname: this.state.name,
      pos: this.state.pos
    }
    let res = await ApiRequest("actReg.asp", "POST", jsoninput);
    if (res.status === "error") {
      errorToast(res.message);
      return;
    }
    console.log(res);
    await Swal.fire({
      title: res.message,
      html: "<label>Thank you for choosing Spark Nature Solution, Please note down your username for login purpose.</label><h3>Username : " + res.memberid + "</h3>",
      icon: "success",
    })
    this.props.history.goBack();
  }
  checkValidPan(panno) {
    if (panno.length !== 10) {
      return false;
    }
    let startstr = panno.substring(0, 5);
    let middlestr = panno.substring(5, 9);
    let endstr = panno.substring(panno.length - 1);
    if (Number(startstr)) {
      return false;
    }
    if (!Number(middlestr)) {
      return false;
    }
    if (Number(endstr)) {
      return false;
    }
    return true;
  }
  render() {
    return (
      <div style={{ background: `url(${assetimages.bg})`, backgroundRepeat: "no-repeat", backgroundSize: "cover", overflow: "auto", height: "100vh" }}>
        <div className="d-flex align-items-center min-vh-100 py-3 py-md-0">
          <div className="container">
            {/* <div>
                                <button style={{float:'left',display:Object.keys(this.props.match.params).length !== 0 ?'block':'none'}} className="mb-5 btn primebtn" type="button">Go To Dashboard</button>
                            </div> */}
            <div className="card login-card col-md-6 mx-auto" style={{ backgroundColor: "#f1fff0f2" }}>
              <div className="card-body">

                <div className="brand-wrapper text-center">
                  <img src={assetimages.logo} style={{height:100}} alt="logo" className="logo" />
                </div>
                <form className="col-lg-12" style={{ display: this.state.steps === 1 ? "block" : "none" }} onSubmit={async (e) => {
                  e.preventDefault();
                  this.actReg();
                }} >
                  <p className="login-card-footer-text">Step 1</p>
                  <div className="form-group" >
                    <label>Sponsor ID</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        sponsorid: e.target.value
                      })
                    }} value={this.state.sponsorid} name="sponsorid" id="sponsorid" className="form-control" placeholder="Sponsor ID" />
                    
                    <label>Email</label>
                    <input type="email" onChange={(e) => {
                      this.setState({
                        email: e.target.value
                      })
                    }} value={this.state.email} name="email" id="email" className="form-control" placeholder="Email ID" />
                    <label>Mobile</label>
                    <input type="text" onChange={(e) => {
                      if (Number(e.target.value) || !e.target.value)
                        this.setState({
                          mobile: e.target.value
                        })
                    }} value={this.state.mobile} name="mobile" id="mobile" className="form-control" placeholder="Mobile number" />
                    <label>Fullname</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        name: e.target.value
                      })
                    }} value={this.state.name} name="fullname" id="fullname" className="form-control" placeholder="Full Name" />
                    <label>Sex</label>
                    <div className="d-flex" style={{ flexWrap: "wrap" }}>
                      <select onChange={(e) => {
                        this.setState({
                          sex: e.target.value
                        })
                      }} value={this.state.sex} name="sex" id="sex" className="form-control col-lg-6 col-md-12">
                        <option value="">--Select Gender --</option>
                        <option value="male">Male</option>
                        <option value="female">Female</option>
                        <option value="others">Others</option>
                      </select>
                      <div className=" col-lg-6 col-md-12 p-0">
                        <DatePicker placeholderText="Date of birth" className={`${window.innerWidth < 720 ? "" : "form-control"}`} selected={this.state.dob} onChange={(date) => this.setState({ dob: date })} />
                      </div>

                      {/* <input type="date" onChange={(e) => {
                                                        this.setState({
                                                            dob: e.target.value
                                                        })
                                                    }} value={this.state.dob} name="dob" id="dob" style={this.state.pickrStyle}  className={`${window.innerWidth < 720 ? "" : "form-control"} col-lg-6 col-md-12`} placeholder="Date of birth" /> */}
                    </div>
                    <label>Password</label>
                    <div className="d-flex">
                      <input type="password" onChange={(e) => {
                        this.setState({
                          password: e.target.value
                        })
                      }} value={this.state.password} name="password" id="password" className="form-control" placeholder="Password" />
                      <input type="password" onChange={(e) => {
                        this.setState({
                          confirmpassword: e.target.value
                        })
                      }} value={this.state.confirmpassword} name="confirmpassword" id="confirmpassword" className="form-control" placeholder="Confirm password" />
                    </div>
                    

                    <p className="login-card-footer-text">Step 2 (Optional)</p>
                    <label>Address line 1</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        address1: e.target.value
                      })
                    }} value={this.state.address1} name="address1" id="address1" className="form-control" placeholder="Address line 1" />
                    <label>Address line 2</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        address2: e.target.value
                      })
                    }} value={this.state.address2} name="address2" id="address2" className="form-control" placeholder="Address line 2" />
                    <label>Address line 3</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        address3: e.target.value
                      })
                    }} value={this.state.address3} name="address3" id="address3" className="form-control" placeholder="Address line 3" />

                    <div className="d-flex">
                      <div>
                        <label>City</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            city: e.target.value
                          })
                        }} value={this.state.city} name="city" id="city" className="form-control" placeholder="City" />

                      </div>
                      <div>
                        <label>State</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            state: e.target.value
                          })
                        }} value={this.state.state} name="state" id="state" className="form-control" placeholder="State" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <label>Country</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            country: e.target.value
                          })
                        }} value={this.state.country} name="country" id="country" className="form-control" placeholder="Country" />
                      </div>
                      <div>
                        <label>Zipcode</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            zipcode: e.target.value
                          })
                        }} value={this.state.zipcode} name="zipcode" id="zipcode" className="form-control" placeholder="Zipcode" />
                      </div>
                    </div>


                    <p className="login-card-footer-text">Step 3</p>

                    <label>Account holder name</label>
                    <input type="text" onChange={(e) => {
                      this.setState({
                        checkname: e.target.value
                      })
                    }} value={this.state.checkname} name="checkname" id="checkname" className="form-control" placeholder="Account holder name" />
                    <div className="d-flex">
                      <div>
                        <label>Aadhar</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            aadhar: e.target.value
                          })
                        }} value={this.state.aadhar} name="aadhar" id="aadhar" className="form-control" placeholder="Aadhar" />
                      </div><div>
                        <label>PAN</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            pan: e.target.value
                          })
                        }} value={this.state.pan} name="pan" id="pan" className="form-control" placeholder="PAN" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <label>Account Number</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            account_number: e.target.value
                          })
                        }} value={this.state.account_number} name="accountnumber" id="accountnumber" className="form-control" placeholder="Account number" />
                      </div>
                      <div>
                        <label>IFSC</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            ifsc: e.target.value
                          })
                        }} value={this.state.ifsc} name="ifsc" id="ifsc" className="form-control" placeholder="IFSC" />
                      </div>
                    </div>

                    <div className="d-flex">
                      <div>
                        <label>Bank Name</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            bank_name: e.target.value
                          })
                        }} value={this.state.bank_name} name="bankname" id="bankname" className="form-control" placeholder="Bankname" />
                      </div>
                      <div>
                        <label>Branch Name</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            branch_name: e.target.value
                          })
                        }} value={this.state.branch_name} name="branchname" id="branchname" className="form-control" placeholder="Branchname" />
                      </div>
                    </div>
                    <div className="d-flex">
                      <div>
                        <label>Nominee Name</label>
                        <input type="text" onChange={(e) => {
                          this.setState({
                            nmname: e.target.value
                          })
                        }} value={this.state.nmname} name="nmname" id="nmname" className="form-control" placeholder="Nominee name" />
                      </div>
                      <div>
                        <label>Nominee relationship</label>
                        <select onChange={(e) => {
                          this.setState({
                            nmrelation: e.target.value
                          })
                        }} value={this.state.nmrelation} name="nmrelation" id="nmrelation" className="form-control">
                          <option value="">-- Select nominee relation --</option>
                          <option value="Father">Father</option>
                          <option value="Wife">Wife</option>
                          <option value="Husband">Husband</option>
                          <option value="Mother">Mother</option>
                          <option value="Brother">Brother</option>
                          <option value="Sister">Sister</option>
                          <option value="Son">Son</option>
                          <option value="Daughter">Daughter</option>
                        </select>
                      </div>
                    </div>
                    <div className="d-flex mt-1 mb-5">
                      <input name="termsandconditions" id="termsandconditions" className="mt-auto mb-auto form-radio-control" type="checkbox" checked={this.state.termsandconditions} value={this.state.termsandconditions} onChange={async () => {
                        this.setState({
                          termsandconditions: !this.state.termsandconditions
                        })

                      }} />
                      <label className="ml-2 mt-auto mb-auto">Terms &amp; Conditions</label>
                    </div>

                    <input name="login" id="login" className="btn btn-block login-btn mb-4" type="submit" value="Submit" />
                  </div>
                </form>
                <p className="login-card-footer-text">{this.state.backText1} <Link to={Object.keys(this.props.match.params).length !== 0 ? "/epin" : "/login"} className="text-reset">{this.state.backText2}</Link></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
